<template>
  <div class="home">
    <v-img :aspect-ratio="16 / 9" :src="pjImage"></v-img>
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: 'Home',
  components: {},
  data: () => ({
    pjImage: require('@/assets/PJGolfCourse.jpg'),
  }),
}
</script>